enum StoreAvailabilityReasonCodeEnum {
	retailItemNotAvailable = 'RETAIL_ITEM_NOT_AVAILABLE',
	retailPriceNotAvailable = 'RETAIL_PRICE_NOT_AVAILABLE',
	retailStockNotAvailable = 'RETAIL_STOCK_NOT_AVAILABLE',
	retailInvalidRetailUnit = 'RETAIL_INVALID_RETAIL_UNIT',
	retailInvalidStoreCode = 'RETAIL_INVALID_STORE_CODE',
	retailInvalidZipCode = 'RETAIL_INVALID_ZIP_CODE',
	validationInvalidId = 'VALIDATION_INVALID_ID',
	validationNotSaleableItem = 'VALIDATION_NOT_SALEABLE_ITEM',
	noAvailableService = 'NO_AVAILABLE_SERVICE'
}

export default StoreAvailabilityReasonCodeEnum;
